// Metadata for this Writing, co-located with the demo it describes.
// The Writing list is built by globbing */meta.tsx (see ../registry.ts), so a demo
// appears by existing and disappears by being deleted — no central array to update.
// `listed: false` keeps the route and its capsule while hiding it from the list.
import { Icons } from '#app/components/icons.tsx'

export const demo = {
	title: 'Multi-modal ingestion — local models, structured out',
	blurb:
		'Statements, PDFs, screenshots and recordings in; structured, sourced entries out — MLX Whisper, Qwen3-VL and OCR, all running locally.',
	label: 'Architecture',
	eyebrow: 'The pipeline',
	href: '/writing/pipeline',
	listed: true,
	dates: '2022 - Present',
	active: true,
	featured: true,
	description:
		'The half of the evidence that was never on-chain. Exchange statements, PDFs, screenshots and screen recordings go in; structured, sourced entries come out — voice transcribed with MLX Whisper, vision and document layout read by Qwen3-VL, OCR over the rest, every model running locally rather than through an API. Each artifact is content-hashed so the same source is never ingested twice and every extracted figure keeps a pointer back to the page, frame or timestamp it came from, and the whole corpus is full-text searchable over 100GB+ of source. It is what makes the ledger work for losses the chain cannot prove on its own — funds frozen on an exchange that never touched a wallet.',
	hardProblem:
		'Half the evidence a crypto ledger needs never touched a chain — funds frozen on an exchange, a bank statement, a screenshot, a screen recording. No amount of on-chain reconstruction reaches that money, and sending the material to a third-party API means handing over somebody’s complete financial history.',
	approach:
		'Ingest it locally. MLX Whisper for audio, Qwen3-VL for vision and document layout, OCR for the rest, every model running on-device. Each artifact is content-hashed so a re-import is a no-op, and every extracted figure keeps a pointer back to the page, frame or timestamp it came from.',
	technologies: [
		'MLX Whisper',
		'Qwen3-VL',
		'OCR',
		'SQLite / FTS5',
		'Python',
		'Local inference',
	],
	links: [
		{
			type: 'Architecture',
			href: '/writing/pipeline',
			icon: <Icons.globe className="size-3" />,
		},
	],
	video: '',
}
